import React from "react"
import { useTaskReportExportContext } from "contexts/TaskReportExportContext"
import FileTypeSelect from "../ReportExport/FileTypeSelect"

const NewTaskReportExportFileTypeSelect = () => {
  const {
    reportExportFileType,
    setReportExportFileType,
  } = useTaskReportExportContext()

  return (
    <FileTypeSelect
      selectedFileType={reportExportFileType}
      onChange={setReportExportFileType}
    />
  )
}

export default NewTaskReportExportFileTypeSelect
